import React from "react";
import {
    GridSelectorItem,
    GridSelectorProps,
    GridSelector,
} from "../GridSelector";

export type MatchdaySelectorItem = GridSelectorItem<number>;

export type MatchdaySelectorProps = Omit<GridSelectorProps<number>, "idPrefix">;

export default function MatchdaySelector(props: MatchdaySelectorProps) {
    return (
        <GridSelector
            {...props}
            idPrefix="matchday-selector"
        />
    );
}
